import { createRoot } from "react-dom/client"
import { installTranslationResilience } from "translation-resilience"

import { sentryDataCollection } from "@forento/core/utilities/sentry"

import App from "~/App"
import { hasAnalyticsConsent } from "~/components/CookieConsent"

// Browser translation rewrites React-managed text nodes, which otherwise crashes commits with NotFoundError
installTranslationResilience({
	onEvent: message => {
		import("@sentry/react").then(Sentry => {
			Sentry.addBreadcrumb({ category: "translation-resilience", message })
		})
	},
})

if (!CONFIG.isDevelopment) {
	import("@sentry/react").then(Sentry => {
		Sentry.init({
			dsn: "https://cf3f5fe1a7974d4c875655649b33bde9@o794413.ingest.sentry.io/5894331",
			// Ties each event to the deployed build, so errors from a tab still running an older bundle are recognizable
			release: CONFIG.apiVersion || undefined,
			dataCollection: sentryDataCollection,
			replaysSessionSampleRate: 0,
			replaysOnErrorSampleRate: 0.1,
			tracesSampleRate: 0.01,
			integrations: [
				Sentry.browserTracingIntegration(),
				Sentry.replayIntegration({
					beforeErrorSampling(event) {
						const error = event.exception?.values?.[0].value
						if (error?.includes("Failed to fetch")) return false
						return true
					},
				}),
			],
		})
	})
}

window.posthog?.init("phc_RpYVUb6Io9CZkERfTEEJhs7SMGiaPAYmBTfRJz7R44t", {
	api_host: "/ph",
	ui_host: "https://eu.posthog.com",
	// Must match CookieConsent at init: switching later copies this origin's ID over the one shared with the landing site
	persistence: hasAnalyticsConsent() ? "localStorage+cookie" : "localStorage",
	cookieWinsOnConflict: true,
	opt_out_capturing_by_default: true,
	capture_pageview: "history_change",
	debug: CONFIG.isDevelopment,
})

document.addEventListener("DOMContentLoaded", () => {
	createRoot(document.getElementById("root")!).render(<App />)
})
